<template>
  <tr v-bind="$attrs">
    <slot name="default" />
  </tr>
  <tr v-if="$slots.childRow">
    <slot name="childRow" />
  </tr>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
